export var ChartHeight;
(function (ChartHeight) {
    ChartHeight["SMALL"] = "small";
    ChartHeight["LARGE"] = "large";
    ChartHeight["FIT"] = "fit";
})(ChartHeight || (ChartHeight = {}));
